import React, { memo } from 'react';

import { AdfoxContextProviderProps } from '../../../../../../utils/AdfoxContext';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };
const P_PARAMS_NEWBUILDING: AdfoxContextProviderProps['pParams'] = { p1: 'dazap', p2: 'y' };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'bvkoa', p2: 'y' };

type ParallaxBannerProps = {
  isNewbuilding: boolean;
  position: number;
};

export const ParallaxBanner = memo<ParallaxBannerProps>(function ParallaxBanner(props) {
  const { isNewbuilding, position } = props;

  return (
    <AdFoxBannerContainer
      position={position}
      bannerName="Баннер параллакс (adFox) десктоп"
      size={SIZE}
      pParams={isNewbuilding ? P_PARAMS_NEWBUILDING : P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
